import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import '../../../Airoom.css';
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { svgIcons } from "../../../style/fonts/SvgIcons";
import Select, { StylesConfig } from "react-select";
import ProgressBar from "./ProgressBar/ProgressBar";
import { useEffect, useState } from "react";
import ProgressStepper from "./ProgressBar/ProgressBar";
import { useGetDefaultlookupsQuery, useGetLeadInquirylookupsQuery, useGetProjectDetailsbyIdQuery, useUpdateProjectDetailsMutation } from "../../../services/EndPointsApis";
import { useFormik } from "formik";
import TextField from "../../../core/common/textFields/TextField";
import Ribbon from "../../../core/common/ribbon/ribbon";
import { toast } from "react-toastify";
import { InputMask } from "@react-input/mask";
import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { DatePicker } from "antd";
import DateComp from "../../../core/common/dateComponent/DateComp";
import FormattedNumber from "../../../core/common/textFields/FormatNumber";


const ProjectUserDetail = ({ }: any) => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams()

  dayjs.extend(customParseFormat);
  const path = location.pathname;
  const isReadOnly = location.pathname.includes('/projects/view-project/details');
  const [currentStep, setCurrentStep] = useState<number>(2);
  const customStyles: StylesConfig = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "rgba(177, 31, 40, 1)",
      },
    }),
  };
  // const { data: projectByIdData, refetch } = useGetProjectDetailsbyIdQuery({ id: params?.projectId });

  const { projectId } = useParams();
  const { data: projectByIdData, refetch } = useGetProjectDetailsbyIdQuery({ id: projectId });
  const [updateProjectDetials, { data: updateProjectDetailData, isLoading, isSuccess, isError, error }] = useUpdateProjectDetailsMutation()
  // const { data: projectByIdData, refetch } = useGetProjectDetailsbyIdQuery({ id: projectId });
  // const { data: getdefaultLookups, refetch: defualtRefetch } = useGetDefaultlookupsQuery('');
  // const { data: leadsInquiryLookups, refetch: LeadInquiryLookups, isLoading: LeadInquiryLoading } = useGetLeadInquirylookupsQuery('');


  const initialValues = {
    id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    firstName: '',
    lastName: '',
    email: '',
    mainPhone: '',
    addressComposite: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zipCode: '',
    zillowEstimate: 0,
    leadProspectId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    leadProspectRecNumber: '',
    leadInquiryId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    leadInquiryRecNumber: '',
    recordNumber: '',
    accountId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    accountName: '',
    accountNumber: '',
    lst_Account: {
      id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
      value: ''
    },
    isActive: true,
    isDeleted: false,
    projectCreatedDate: '2024 - 10 - 15T07:01: 51.631Z',
    projectUpdateDate: '2024 - 10 - 15T07:01: 51.631Z',
    saleAcceptedDate: '',
    projectAutoId: 0,
    budget: 0,
    lstStatus: 0,
    lstSubStatus: 0,
    lstPriority: 0,
    lst_Priority: {
      id: 0,
      value: ''
    },
    projBudgetNotes: '',
    projectCostAmount: 0,
    planDuesAmount: 0,
    projLeadInTakeNotes: '',
    lst_Status: {
      id: 0,
      value: ''
    },
    lst_ReviewedBy:
    {
      id: 0,
      value: ''
    },
    lst_SubStatus: {
      id: 0,
      value: ''
    },
    lst_Country: {
      id: 0,
      value: ''
    },
    lst_Need: {
      id: 0,
      value: ''
    },
    saleDate: '',
    reviewedCostAmount: 0,
    isCash: false,
    isLFC: false,
    isOwnersBank: false,
    isFinanced: false,
    saleStatus: "",
    saleAmount: 0,
    downPaymentAmount: 0,
    contingencies: 0,
    downPaymentDate: null,
  }
  const [updateId, setUpdateId] = useState(0);

  useEffect(() => {
    if (projectByIdData?.result && Object.keys(projectByIdData?.result).length > 0) {
      setUpdateId(projectByIdData?.result?.id);
      formik.setValues({ ...projectByIdData?.result });
    } else {
      setUpdateId(0);
    }
  }, [projectByIdData]);

  const formik = useFormik({
    initialValues,
    // validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      updateProjectDetials(values)

    }
  })
  // useEffect(() => {
  //   if (projectId) {
  //     // refetch()
  //     LeadInquiryLookups()
  //     defualtRefetch()
  //   }
  // }, [projectId])a

  const { resetForm } = formik;

  useEffect(() => {
    if (isSuccess) {
      toast.success(updateProjectDetailData?.message);
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError && error) {
      let errorMessage: string = 'Something went wrong';

      if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
        errorMessage = (error.data as { message: string }).message;
      }
      toast.error(errorMessage);
    }

  },
    [isError, error]);

  const handleBack = () => {
    navigate('/projects');
  };
  const items = [
    { icon: svgIcons.BackIcon, onClick: handleBack },
  ];

  const handleSaleAcceptedDateChange = (date: Dayjs | null) => {
    // setSelectedRetainerDate(date);
    formik.setFieldValue('retainerCollectionDate', date)
  };
  useEffect(() => {
    refetch()
  }, [])

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          {/* <Ribbon
            items={items}
            buttonText={isLoading ? "Loading..." : "Save"}
            onClickbtn={formik.handleSubmit}
            buttonClass="add-popup ribbon-btn" /> */}
        </div>
        <div className="col-md-12">
          {/* <ProgressStepper currentStep={currentStep} setCurrentStep={setCurrentStep}/> */}
        </div>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="row" style={{ height: '599px', overflow: 'auto' }}>
          <div className="col-md-8">
            <div className="row">
              <div className="col-md-6">
                <div className="card">
                  <div className="card-body">
                    <h5>
                      Project Details
                    </h5>
                    {/* <div className="col-md-12 mt-2">
                      <TextField
                        label="Subject"
                        
                        type="text"
                        className="form-control"
                        placeholder="Enter Subject"
                        {...formik.getFieldProps('subject')}
                        disabled />
                    </div> */}
                    <div className="col-md-12 mt-2">
                      <TextField
                        label="Title"

                        type="text"
                        className="form-control"
                        {...formik.getFieldProps('title')}
                        disabled />
                    </div>
                    {/* <div className="col-md-12 mt-2">
                      <label className="col-form-label">
                        Need
                      </label>
                      <Select
                        styles={customStyles}
                        className="select"
                        options={getdefaultLookups?.result?.Lst_Need?.map((option: any) => ({
                          label: option?.value,
                          value: option?.id
                        }))}
                        value={
                          formik.values.lst_Need?.id
                            ? {
                              value: formik.values.lst_Need?.id,
                              label: formik.values.lst_Need?.value || '',
                            }
                            : null
                        }
                        onChange={(selectedOption: any) => {
                          formik.setFieldValue(`lst_Need.id`, selectedOption?.value || null);
                          formik.setFieldValue(`lst_Need.value`, selectedOption?.label || null);
                        }}
                        isDisabled={isReadOnly}
                      />
                    </div> */}
                    <div className="col-md-12 mt-2">
                      <TextField
                        label="Need"

                        type="text"
                        className="form-control"
                        {...formik.getFieldProps('lst_Need.value')}
                        disabled />
                    </div>
                    <div className="col-md-12 mt-2">
                      <TextField
                        label="Description"

                        type="text"
                        className="form-control"
                        {...formik.getFieldProps('description')}
                        disabled />
                    </div>

                    {/* <div className="col-md-12 mt-2">
                      <label className="col-form-label">
                        Project Status<span className="text-danger"> *</span>
                      </label>
                      <Select
                        styles={customStyles}
                        className="select"
                        options={getdefaultLookups?.result?.Lst_ProjectStatus?.map((option: any) => ({
                          label: option?.value,
                          value: option?.id
                        }))}
                        value={
                          formik.values.lst_Status?.id
                            ? {
                              value: formik.values.lst_Status?.id,
                              label: formik.values.lst_Status?.value || '',
                            }
                            : null
                        }
                        onChange={(selectedOption: any) => {
                          formik.setFieldValue(`lst_Status.id`, selectedOption?.value || null);
                          formik.setFieldValue(`lst_Status.value`, selectedOption?.label || null);
                        }}
                        isDisabled={isReadOnly}
                      />
                    </div>
                    <div className="col-md-12 mt-2">
                      <label className="col-form-label">
                        Project Sub-Status<span className="text-danger"> *</span>
                      </label>
                      <Select
                        styles={customStyles}
                        className="select"
                        options={getdefaultLookups?.result?.Lst_SubStatus?.map((option: any) => ({
                          label: option?.value,
                          value: option?.id
                        }))}
                        value={
                          formik.values.lst_SubStatus?.id
                            ? {
                              value: formik.values.lst_SubStatus?.id,
                              label: formik.values.lst_SubStatus?.value || '',
                            }
                            : null
                        }
                        onChange={(selectedOption: any) => {
                          formik.setFieldValue(`lst_SubStatus.id`, selectedOption?.value || null);
                          formik.setFieldValue(`lst_SubStatus.value`, selectedOption?.label || null);
                        }}
                        isDisabled={isReadOnly}
                      />
                    </div>
                    <div className="col-md-12 mt-2">
                      <label className="col-form-label">
                        Project  Priority<span className="text-danger"> *</span>
                      </label>
                      <Select
                        styles={customStyles}
                        className="select"
                        options={leadsInquiryLookups?.result?.Lst_PriorityCode?.map((option: any) => ({
                          label: option?.value,
                          value: option?.id
                        }))}
                        value={
                          formik.values.lst_Priority?.id
                            ? {
                              value: formik.values.lst_Priority?.id,
                              label: formik.values.lst_Priority?.value || '',
                            }
                            : null
                        }
                        onChange={(selectedOption: any) => {
                          formik.setFieldValue(`lst_Priority.id`, selectedOption?.value || null);
                          formik.setFieldValue(`lst_Priority.value`, selectedOption?.label || null);
                        }}
                        isDisabled={isReadOnly}
                      />
                    </div>
                    <div className="col-md-12 mt-2">
                      <label className="col-form-label">
                        Project Budget Notes<span className="text-danger"> *</span>
                      </label>
                      <textarea className="form-control"
                        placeholder="Enter Description"
                        disabled={isReadOnly}
                        {...formik.getFieldProps('projBudgetNotes')}
                      ></textarea>

                    </div>
                    <div className="col-md-12 mt-2">
                      <label className="col-form-label">
                        Lead Intake Notes<span className="text-danger"> *</span>
                      </label>
                      <textarea className="form-control"
                        placeholder="Enter Description"
                        disabled={isReadOnly}
                        {...formik.getFieldProps('projLeadInTakeNotes')}
                      ></textarea>

                    </div> */}
                  </div>
                </div>
                <div className="card">
                  <div className="card-body">
                    <h5 className="">Sales:</h5>
                    <div className="col-md-12 mt-2">
                      <TextField
                        label="Sale Status"

                        type="text"
                        className="form-control"
                        {...formik.getFieldProps('saleStatus')}
                        disabled />
                    </div>

                    <div className="col-md-12 mt-2">
                      <div className=''>
                        <div className='input-label '>
                          Sale Amount
                        </div>
                        <div className='br-gray  text-end py-2 px-3 bg-gray'>
                          <FormattedNumber value={formik.values?.saleAmount} />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 mt-2">
                      <div className=''>
                        <div className='input-label '>
                          Down Payment Amount
                        </div>
                        <div className='br-gray text-end py-2 px-3 bg-gray'>
                          <FormattedNumber value={formik.values?.downPaymentAmount} />
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-md-12 mt-2">
                      <label className='input-label'>Sale Accepted Date</label>
                      <DatePicker
                        className="form-control datetimepicker deals-details "
                        onChange={handleSaleAcceptedDateChange}
                        disabled={isReadOnly}
                        value={formik.values?.saleAcceptedDate ? dayjs(formik.values?.saleAcceptedDate, 'YYYY-MM-DD') : null}
                      />
                    </div> */}
                    <div className="col-md-12 mt-2">
                      <TextField
                        label="Sale Accepted Date"
                        type="text"
                        className="form-control"
                        value={formik.values.saleAcceptedDate ? dayjs(formik.values.saleAcceptedDate)?.format("MMM-DD-YYYY") : ""}
                        disabled />
                    </div>
                    <div className="col-md-12 mt-2">
                      <TextField
                        label="Sale Date"
                        type="text"
                        className="form-control"
                        value={formik.values.saleDate ? dayjs(formik.values.saleDate).format("MMM-DD-YYYY") : ""}
                        disabled />
                    </div>
                    <div className="col-md-12 mt-2">
                      <TextField
                        label="Down Payment Received Date"
                        type="text"
                        className="form-control"
                        value={formik.values.downPaymentDate ? dayjs(formik?.values?.downPaymentDate).format("MMM-DD-YYYY") : ""}
                        disabled />
                    </div>
                    <div className="col-md-12 mt-2">
                      <label className="input-label">
                        Management Intervention
                      </label>
                      <label className="checkboxs mt-3">
                        <input
                          type="checkbox"
                          defaultChecked
                        />
                        <span className="checkmarks checkmarks-infoPage" />
                      </label>
                    </div>
                    <div className="col-md-12 mt-4">
                      <TextField
                        label="Intervention Description"
                        type="text"
                        {...formik.getFieldProps("interventionDescription")}
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div className='card'>
                  <div className='card-body card-css'>
                    <h5>
                      Home Address
                    </h5>
                    <div className="col-md-12">
                      <TextField
                        label="Address Composite"
                        type="text"
                        {...formik.getFieldProps("addressComposite")}
                        disabled
                      />
                    </div>
                    <div className="col-md-12">
                      <TextField
                        label="Address Line 1"
                        type="text"
                        {...formik.getFieldProps("addressLine1")}
                        disabled

                      />
                    </div>
                    <div className="col-md-12">
                      <TextField
                        label="Address Line 2"
                        type="text"
                        {...formik.getFieldProps("addressLine2")}
                        disabled
                      />
                    </div>
                    <div className="col-md-12">
                      <TextField
                        label="City"
                        type="text"
                        {...formik.getFieldProps("city")}
                        disabled
                      // icon={svgIcons.LockIcon}
                      />
                    </div>
                    <div className="col-md-12">
                      <TextField
                        label="State or Province"
                        type="text"
                        {...formik.getFieldProps("state")}
                        disabled

                      // icon={svgIcons.LockIcon}

                      />
                    </div>
                    <div className="col-md-12">
                      <label>Postal Code</label>
                      <InputMask mask="_____-____"
                        replacement={{ _: /\d/ }}
                        className="form-control"
                        {...formik.getFieldProps("zipCode")}
                        disabled
                      />
                    </div>
                    {/* <div className="col-md-12">
                                    <TextField
                                        label="Postal Code \"
                                        type="text"
                                        {...formik.getFieldProps("postalCodeLookup")}
                                        disabled
                                    />
                                </div> */}
                  </div>
                </div>
              </div>

              <div className="col-md-6">

                <div className="card">
                  <div className="card-body">
                    <h5>Identify Contact</h5>
                    <div className="col-md-12 mt-2">
                      <TextField
                        label="Lead Prospect Name"
                        type="text"

                        className="form-control"
                        {...formik.getFieldProps('leadProspectName')}
                        disabled />
                    </div>
                    {/* <div className="col-md-12 mt-2">
                     
                      <label className="col-form-label">
                        Lead Prospect<span className="text-danger"> *</span>
                      </label>
                      <div className="br-gray form-control">
                        <Link to={`/leadsProspect/editLead/${formik.values.leadProspectId}`}>
                          <span className='me-1'> {svgIcons?.AccountIconBlue}</span>
                          {formik?.values?.leadProspectRecNumber}
                        </Link>
                      </div>
                    </div> */}

                    {/* <div className="col-md-12 mt-2">
                     
                      <label className="col-form-label">
                        Lead Inquiry<span className="text-danger"> *</span>
                      </label>
                      <div className="br-gray form-control">
                        <Link to={`/leadsInquiry/editLeadInquiry/${formik.values.leadInquiryId}`}>
                          <span className='me-1'> {svgIcons?.AccountIconBlue}</span>
                          {formik?.values?.leadInquiryRecNumber}
                        </Link>
                      </div>
                    </div> */}
                    {/* <div className="col-md-12 mt-2">
                      <label className="col-form-label">
                        Account<span className="text-danger"> *</span>
                      </label>
                      <div className="br-gray form-control">
                        <Link to={`/accounts/EditAccounts/${formik.values.accountId}`}>
                          <span className='me-1'> {svgIcons?.AccountIconBlue}</span>
                          {formik?.values?.accountName}
                        </Link>
                      </div>
                    </div> */}
                    <div className="col-md-12 mt-2">
                      <TextField
                        label="Contact"
                        type="text"

                        className="form-control"
                        {...formik.getFieldProps('contactName')}
                        disabled />
                    </div>
                    <div className="col-md-12 mt-2">
                      <TextField
                        label="Contact Main Phone"
                        type="text"

                        className="form-control"
                        {...formik.getFieldProps('mainPhone')}
                        disabled />
                    </div>
                    <div className="col-md-12 mt-2">
                      <TextField
                        label="Contact Email"
                        type="text"

                        className="form-control"
                        {...formik.getFieldProps('email')}
                        disabled />
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-body">
                    <h5>Cost Review</h5>
                    <div className="col-md-12 mt-2">
                      <div className=''>
                        <div className='input-label '>
                          Reviewed Cost Amount
                        </div>
                        <div className='br-gray text-end py-2 px-3 bg-gray'>
                          <FormattedNumber value={formik.values?.reviewedCostAmount} />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 mt-2">
                      <TextField
                        label="Reviewed By"

                        type="text"
                        className="form-control"
                        disabled
                        {...formik.getFieldProps('lst_ReviewedBy.value')}
                      />
                    </div>
                    <div className="col-md-12 mt-2">
                      <TextField
                        label="Cost Review Notes"

                        disabled
                        type="text"
                        className="form-control"
                        {...formik.getFieldProps('costReviewNotes')}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card">
              <div className="card-body">
                <div className="col-md-12 mt-2">
                  <div className=''>
                    <div className='input-label '>
                      Project Cost Amount
                    </div>
                    <div className='br-gray text-end py-2 px-3 bg-gray'>
                      <FormattedNumber value={formik.values?.projectCostAmount} />
                    </div>
                  </div>
                </div>
                <div className="col-md-12 mt-2">
                  <div className=''>
                    <div className='input-label '>
                      Plan Dues Amount
                    </div>
                    <div className='br-gray text-end py-2 px-3 bg-gray'>
                      <FormattedNumber value={formik.values?.planDuesAmount} />
                    </div>
                  </div>
                </div>
                <div className="col-md-12 mt-2">
                  <TextField
                    label="# of Contingencies"
                    fieldClass='text-end'

                    disabled
                    type="number"
                    className="form-control"
                    {...formik.getFieldProps('contingencies')}
                  />
                </div>
                <div className="col-md-12 mt-2">
                  <TextField
                    label="# of warrenty Exc"
                    fieldClass='text-end'

                    type="number"
                    disabled
                    className="form-control"
                    {...formik.getFieldProps('warranty')}
                  />
                </div>
                <div className="col-md-5 mt-2 d-flex justify-content-between">
                  <label className="input-label">
                    Financed ?
                  </label>
                  <label className="checkboxs mt-2">
                    <input
                      type="checkbox"
                      disabled
                      checked={formik.values?.isFinanced}
                      // disabled={viewOnly}
                      {...formik.getFieldProps("isFinanced")}
                    />
                    <span className="checkmarks" />
                  </label>
                </div>
                <div className="col-md-5 mt-2 d-flex justify-content-between">
                  <label className="input-label">
                    Cash ?
                  </label>
                  <label className="checkboxs mt-2">
                    <input
                      type="checkbox"
                      disabled
                      checked={formik.values?.isCash}
                      // disabled={viewOnly}
                      {...formik.getFieldProps("isCash")}
                    />
                    <span className="checkmarks" />
                  </label>
                </div>
                <div className="col-md-5 mt-2 d-flex justify-content-between">
                  <label className="input-label">
                    Owners Bank ?
                  </label>
                  <label className="checkboxs mt-2">
                    <input
                      type="checkbox"
                      disabled
                      checked={formik.values?.isOwnersBank}
                      // disabled={viewOnly}
                      {...formik.getFieldProps("isOwnersBank")}
                    />
                    <span className="checkmarks" />
                  </label>
                </div>
                <div className="col-md-5 mt-2 d-flex justify-content-between">
                  <label className="input-label">
                    Using LFC ?
                  </label>
                  <label className="checkboxs mt-2">
                    <input
                      type="checkbox"
                      disabled
                      checked={formik.values?.isLFC}
                      // disabled={viewOnly}
                      {...formik.getFieldProps("isLFC")}
                    />
                    <span className="checkmarks" />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div >
      </form >
    </>
  )
}

export default ProjectUserDetail
